import { GetImageQueryVariables, Image } from '@akin-home/amplify';
import { getImageQuery } from '@akin-home/images/frontend';
import { useQuery } from 'react-query';

export const useGetImage = (params: GetImageQueryVariables) => {
  return useQuery(['image', params.id], () => getImageQuery(params), {
    enabled: !!params.id,
    select(data) {
      return (data.getImage || undefined) as Image | undefined;
    },
  });
};
